import ReadWriteRecipientViewState from 'owa-recipient-types/lib/types/ReadWriteRecipientViewState';
import { action } from 'satcheljs';

export default action(
    'updateRecipientsForSmartCompose',
    (recipients: ReadWriteRecipientViewState[]) => ({
        recipients: recipients,
    })
);
